import { render, staticRenderFns } from "./PopupReformationResult.vue?vue&type=template&id=64127466&scoped=true"
import script from "./PopupReformationResult.vue?vue&type=script&lang=js"
export * from "./PopupReformationResult.vue?vue&type=script&lang=js"
import style0 from "./PopupReformationResult.vue?vue&type=style&index=0&id=64127466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64127466",
  null
  
)

export default component.exports